import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import styles from './Login.module.css';
import logo from "../../starLogo.png";

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      {/* Brand panel */}
      <div className={styles.brand}>
        <div className={styles.brand_logo}>
        <img src={logo} alt="iAssets Logo" className={styles.logo_image} />
          <span className={styles.logo_text}>i<span>Assets</span></span>
        </div>
        <div className={styles.brand_copy}>
          <h2>Enterprise Asset Management, Simplified.</h2>
          <p>Track, maintain, and optimise every asset across your plants and facilities — all from one platform.</p>
        </div>
        <div className={styles.brand_stats}>
          {[['74.3%','OEE Score'],['96.4%','Compliance'],['312h','MTBF']].map(([v,l]) => (
            <div key={l} className={styles.stat}>
              <div className={styles.stat_value}>{v}</div>
              <div className={styles.stat_label}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Form panel */}
      <div className={styles.form_panel}>
        <div className={styles.form_head}>
          <h1>Welcome back 👋</h1>
          <p>Sign in to your iAssets account</p>
        </div>

        {error && <div className={styles.alert_error}>⚠ {error}</div>}

        <form onSubmit={submit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="email">Email Address</label>
            <input id="email" name="email" type="email" value={form.email}
              onChange={handle} placeholder="you@company.com" required autoFocus />
          </div>
          <div className={styles.field}>
            <label htmlFor="password">Password</label>
            <input id="password" name="password" type="password" value={form.password}
              onChange={handle} placeholder="••••••••" required />
          </div>
          <div className={styles.form_opts}>
            <label className={styles.remember}>
              <input type="checkbox" /> Remember me
            </label>
            <button type="button" className={styles.forgot}>Forgot password?</button>
          </div>
          <button type="submit" className={styles.submit_btn} disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In →'}
          </button>
        </form>

     {/*    {<div className={styles.demo_hint}>
          <strong>Demo credentials</strong><br />
          Email: <code>admin@iassets.app</code> &nbsp;|&nbsp; Password: <code>Admin@123</code>
        </div>} */}
      </div>
    </div>
  );
}
